export const passesConstants = {
    GET_GENERAL_SETTINGS: "GET_GENERAL_SETTINGS",
    GET_PLACE_DETAIL_BASED_ON_ID: "GET_PLACE_DETAIL_BASED_ON_ID",
    GET_CART_DETAIL: "GET_CART_DETAIL",
    GET_CREATED_ORDER_DETAIL: "GET_CREATED_ORDER_DETAIL",
    IS_CART_DELETED: "IS_CART_DELETED",
    RELOAD_PAGE: "RELOAD_PAGE",
    IS_USER_DELETED_AND_LOGOUT: "IS_USER_DELETED_AND_LOGOUT",
    SET_CART_EXPIRE_BANNER_CLOSED: "SET_CART_EXPIRE_BANNER_CLOSED",
}